import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface ScreenInputTemporaryState {
  /** 画面URL */
  url: string;
  /** 入力情報 */
  inputParams: any;
}

/**
 * ### ScreenInputTemporary store
 *
 * - 無操作タイムアウト時に入力情報が削除されてしまうことを防ぐためのstore
 * - APIリクエスト前にSETする
 * - 使用後にINITIALIZEする
 */
@Module({ name: "screenInputTemporary" })
export default class ScreenInputTemporary extends VuexModule implements ScreenInputTemporaryState {
  /** 画面URL */
  url: string = "";
  /** 入力情報 */
  inputParams: any = null;

  @Mutation
  private INITIALIZE_SCREEN_INPUT_TEMPORARY(): void {
    this.url = "";
    this.inputParams = null;
    return;
  }

  @Mutation
  private SET_SCREEN_INPUT_TEMPORARY(params: { url: string; inputParams: any }): void {
    this.url = params.url;
    this.inputParams = params.inputParams;
    return;
  }

  @Action({ rawError: true })
  public async initializeScreenInputTemporary(): Promise<void> {
    this.INITIALIZE_SCREEN_INPUT_TEMPORARY();
    return;
  }

  @Action({ rawError: true })
  public async setScreenInputTemporary(payload: { url: string; inputParams: any }): Promise<void> {
    this.SET_SCREEN_INPUT_TEMPORARY(payload);
    return;
  }
}
